import React from 'react'
import { ProductWithActiveColour } from '../../types'

interface Props {
  product: ProductWithActiveColour
}

export const ProductImage: React.FC<Props> = ({ product }) => (
  <img
    className="productblock-img"
    src={product.activeColour.image}
    alt={product.title}
  />
)
